import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import Icon from '../../../components/AppIcon';

const VisaStatusCard = ({ status }) => {
  const { t, currentLanguage } = useLanguage();

  const statusConfig = {
    pending: {
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      label: { fr: 'En attente', ar: 'قيد الانتظار' }
    },
    approved: {
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      label: { fr: 'Approuvé', ar: 'موافق عليه' }
    },
    rejected: {
      icon: 'XCircle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      label: { fr: 'Rejeté', ar: 'مرفوض' }
    },
    processing: {
      icon: 'RefreshCw',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      label: { fr: 'En traitement', ar: 'قيد المعالجة' }
    }
  };

  const config = statusConfig?.[status?.type] || statusConfig?.pending;

  return (
    <div className="flex items-center justify-between p-4 md:p-5 bg-card rounded-lg border border-border hover:shadow-warm transition-smooth">
      <div className="flex items-center gap-3 md:gap-4">
        <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${config?.bgColor} flex items-center justify-center flex-shrink-0`}>
          <Icon name={config?.icon} size={24} className={config?.color} />
        </div>
        <div>
          <p className="text-sm md:text-base font-medium text-foreground mb-1">
            {config?.label?.[currentLanguage]}
          </p>
          <p className="caption text-muted-foreground">
            {status?.description}
          </p>
        </div>
      </div>
      <div className="text-right">
        <p className="text-xl md:text-2xl font-semibold text-foreground data-text">
          {status?.count}
        </p>
        <p className="caption text-muted-foreground">
          {t('dashboard.visas')}
        </p>
      </div>
    </div>
  );
};

export default VisaStatusCard;